import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad7.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[9];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[10].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[10].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[8].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[8].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              En todas las escuelas del Perú se enseña castellano. ¿No sería
              interesante que pudiéramos aprender también alguna lengua
              originaria?
            </li>
            <li>
              Hazle estas preguntas a un compañero, compañera o familiar y
              escribe sus respuestas en el cuadro.
            </li>
          </ul>

          <div>
            <table className="actividad">
              <tr>
                <td className="text-center">
                  <small>Nombre de mi compañero, compañera o familiar: </small>
                  <input type="text" className="form-control" />
                </td>
                <td className="text-center">
                  <p>Respuestas:</p>
                </td>
              </tr>
              <tr>
                <td>
                  <small>
                    a. Escoge una de estas lenguas originarias del Perú que
                    quisieras aprender en la escuela: awajún, aimara o
                    ashaninka.
                  </small>
                </td>
                <td className="text-center">
                  <input type="text" className="form-control" />
                </td>
              </tr>
              <tr>
                <td>
                  <small>
                    b. Da una razón por la que sería importante aprender la
                    lengua que has escogido:
                  </small>
                </td>
                <td className="text-center">
                  <textarea type="text" className="form-control" rows="6" />
                </td>
              </tr>
            </table>
          </div>
          <ul className="mt-5">
            <li>Ahora escribe aquí tus respuestas a estas preguntas.</li>
          </ul>
          <div>
            <table className="actividad">
              <tr>
                <td className="text-center">
                  <small>Mi nombre: </small>
                  <input type="text" className="form-control" />
                </td>
                <td className="text-center">
                  <p>Respuestas:</p>
                </td>
              </tr>
              <tr>
                <td>
                  <small>
                    a. Escoge una de estas lenguas originarias del Perú que
                    quisieras aprender en la escuela: awajún, aimara o
                    ashaninka.
                  </small>
                </td>
                <td className="text-center">
                  <input type="text" className="form-control" />
                </td>
              </tr>
              <tr>
                <td>
                  <small>
                    b. Da una razón por la que sería importante aprender la
                    lengua que has escogido:
                  </small>
                </td>
                <td className="text-center">
                  <textarea type="text" className="form-control" rows="6" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Explique que las siguientes actividades buscan involucrarlos en el
            reconocimiento y el valor de las lenguas originarias del Perú, así
            como darles alguna información sobre las distintas variedades del
            castellano peruano. Resalte que es importante tomar acciones que
            contribuyan a que todas las lenguas y variedades en el Perú sean
            aceptadas y valoradas.
          </li>
          <li>
            Lea las indicaciones de la actividad: En todas las escuelas del Perú
            se enseña castellano. ¿No sería interesante que pudiéramos aprender
            también alguna lengua originaria? Hazle estas preguntas a un
            compañero, compañera o familiar y escribe sus respuestas en el
            cuadro. Explique que deberá llenar el cuadro con la información de
            su compañero, compañera o familiar y luego, en el segundo cuadro,
            escribir sus propias respuestas.
          </li>
          <li>
            Dé un tiempo para trabajar. Retome las respuestas. Para ello, puede
            realizar un cuadro y realizar las siguientes preguntas:
            <ul>
              <li>
                <i>
                  “Vamos a ver qué lengua originaria quisieran aprender.
                  Levanten la mano los que escribieron awajún”.
                </i>
              </li>
              <li>
                <i>
                  “Ahora quiero que me expliquen por qué quisieran aprender esas
                  lenguas”. Retome algunas razones y anótelas en cuadro.
                </i>
              </li>
            </ul>
          </li>

          <li>Reflexionen sobre las razones dadas.</li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
